export const createStyles = (theme: any) => ({
  preview: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    boxSizing: 'border-box',
    width: '100%',
    height: '56px',
    minWidth: 0,
    padding: '8px 12px',
    gap: '12px',
    overflow: 'hidden',
    opacity: 1,
    borderRadius: '4px',
    backgroundColor: {
      xs: theme.palette.background.paper,
      md: theme.palette.background.default,
    },
    border:
      theme.palette.mode === 'dark'
        ? `1px solid ${theme.palette.divider}`
        : '1px solid rgba(35, 31, 41, 0.16)',
  },
  label: {
    flexShrink: 0,
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: '1.25rem',
  },
  participantSummary: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    minWidth: 0,
    overflow: 'hidden',
  },
  avatarStack: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
  },
  avatarWrapper: (index: number, total: number) => ({
    display: 'inline-flex',
    flexShrink: 0,
    ml: index === 0 ? 0 : '-6px',
    zIndex: total - index,
    borderRadius: '100px',
    '&:focus-visible': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
  }),
  avatar: {
    boxSizing: 'border-box',
    width: '32px',
    height: '32px',
    minWidth: '32px',
    minHeight: '32px',
    borderRadius: '100px',
    border: '2px solid transparent',
    backgroundColor: 'rgba(93, 83, 108, 1)',
    color: theme.palette.common.white,
    fontSize: '0.75rem',
  },
  imageAvatar: {
    borderColor: theme.palette.background.paper,
  },
});
